export const FINDINGS_OPTIONS = [
  'Job Map Entities',
  'ASTM Summary',
  'VEC Summary',
  'Oil-Gas Summary',
  'Orphans Summary',
  'Adjoining Properties Summary',
  'Database Description',
  'Soils Summary',
];

export const ADJOINING_BOUNDARIES_TYPE = 'adjoining_properties_boundaries';
export const ADJOINING_SUMMARY_TYPE = 'Adjoining Properties Summary';

export const isAdjoiningFindingsType = (type: string) =>
  type === ADJOINING_SUMMARY_TYPE || type === ADJOINING_BOUNDARIES_TYPE;

export const getFindingsTypeLabel = (type: string) =>
  type === ADJOINING_BOUNDARIES_TYPE ? ADJOINING_SUMMARY_TYPE : type;

export const estimateFindingsPanelMinWidth = (label: string) => {
  const longestOption = FINDINGS_OPTIONS.reduce(
    (longest, option) => (option.length > longest.length ? option : longest),
    ''
  );
  const targetLabel = label.length >= longestOption.length ? label : longestOption;
  return Math.max(360, targetLabel.length * 11 + 104);
};

export const getFindingsPanelMinWidth = (type: string): number | undefined => {
  if (!type) {
    return undefined;
  }

  return estimateFindingsPanelMinWidth(getFindingsTypeLabel(type));
};
